module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/client/client-photo/client-photo.scss
// module id = ./web/modern/components/client/client-photo/client-photo.scss
// module chunks = 0